import React, { useEffect, useState } from 'react';
import { useAppContext } from './AppContext';

const ScrollTopBottom = () => {
    const [showButton, setShowButton] = useState(false);
    const [atTop, setAtTop] = useState(true);
    const {loading} = useAppContext();

    const checkScroll = () => {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;

        const isScrollable = fullHeight > windowHeight + 1;
        setShowButton(isScrollable);

        const nearTop = scrollY < 100;
        const nearBottom = scrollY + windowHeight >= fullHeight - 100;

        setAtTop(nearTop && isScrollable);
    };

    useEffect(() => {
        // Initial check after page render
        setTimeout(checkScroll, 300); // Slight delay to ensure DOM is ready

        window.addEventListener('scroll', checkScroll);
        window.addEventListener('resize', checkScroll);

        return () => {
            window.removeEventListener('scroll', checkScroll);
            window.removeEventListener('resize', checkScroll);
        };
    }, [loading]);

    const handleClick = () => {
        window.scrollTo({
            top: atTop ? document.documentElement.scrollHeight : 0,
            behavior: 'smooth',
        });
    };

    if (!showButton) return null;

    return (
        <button
            className='scrollTobBottomBtn'
            onClick={handleClick}
            title={atTop ? 'Scroll to Bottom' : 'Scroll to Top'}
        >
            {atTop ? '↓' : '↑'}
        </button>
    );
};

export default ScrollTopBottom;
